<template src="./template.html"></template>
<style lang="scss" src="@/assets/styles/_customs.scss"></style>

<script>
import { mapActions, mapState } from 'vuex'
import { createPopper } from '@popperjs/core'

export default {
  name: 'CartItem',
  props: {
    item: Object,
  },
  data() {
    return {
      productOptions: {},
    }
  },
  computed: {
    ...mapState('settings', [
      'settings',
      'pendingSettings',
    ]),
    ...mapState('summary', [ 'coinPacksOnly' ]),
    isVirtualCurrency() {
      return !this.pendingSettings &&
             this.settings.active_features &&
             this.settings.active_features.use_virtual_currency &&
             !this.coinPacksOnly
    },
    maxQuantity() {
      const list = []
      for (let i = 1; i <= this.productOptions.max_quantity; i++) {
        list.push(i)
      }
      return list
    },
    append_to_body() {
      return document.querySelector('.quick-cart-container') && document.querySelector('.quick-cart-container').classList.contains('quick-cart-container__mobile')
    },
  },
  async created() {
    const { product } = await this.getProductOptions(this.item.id)
    this.productOptions = product

  },
  methods: {
    ...mapActions('summary', [
      'getProductOptions',
      'updateCartItemOption',
      'removeItem',
    ]),
    getOptionId({ id }) {
      if (!this.item.product.options) return false
      let val
      this.item.product.options.forEach(opt => {
        if (opt.type_id === id) {
          return val = opt.value_id
        }
      })
      return val
    },
    getOptionValue({ id }) {
      if (!this.item.product.options) return false
      let val
      this.item.product.options.forEach(opt => {
        if (opt.type_id === id) {
          return val = opt.value_title
        }
      })
      return val
    },
    async updateCartItemVariant(variant) {
      if (this.item.product.variant_item.id !== variant) {
        await this.updateCartItemOption({ id: this.item.id, option: { variant } })
      }
    },
    async updateCartItemQuantity(quantity) {
      if (this.item.quantity !== quantity) {
        await this.updateCartItemOption({ id: this.item.id, option: { quantity } })
      }
    },
    async updateCartItemOptions(value) {
      await this.updateCartItemOption({ id: this.item.id, option: { option: value } })
    },
    withPopper(dropdownList, component, { width }) {
      /**
       * We need to explicitly define the dropdown width since
       * it is usually inherited from the parent with CSS.
       */
      dropdownList.style.width = width

      /**
       * Here we position the dropdownList relative to the $refs.toggle Element.
       *
       * The 'offset' modifier aligns the dropdown so that the $refs.toggle and
       * the dropdownList overlap by 1 pixel.
       *
       * The 'toggleClass' modifier adds a 'drop-up' class to the Vue Select
       * wrapper so that we can set some styles for when the dropdown is placed
       * above.
       */
      const popper = createPopper(component.$refs.toggle, dropdownList, {
        placement: 'bottom',
        modifiers: [
          {
            name: 'offset', options: {
              offset: [
                0,
                -1,
              ],
            },
          },
          {
            name: 'toggleClass',
            enabled: true,
            phase: 'write',
            fn({ state }) {
              component.$el.classList.toggle('drop-up', state.placement === 'top')
            },
          },
        ],
      })

      /**
       * To prevent memory leaks Popper needs to be destroyed.
       * If you return function, it will be called just before dropdown is removed from DOM.
       */
      return () => popper.destroy()
    },
  },
}
</script>
